import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = {
  key: 0,
  class: "fas fa-check-circle text-success"
}
const _hoisted_3 = {
  key: 1,
  class: "fa fa-times-circle text-danger"
}
const _hoisted_4 = {
  key: 1,
  class: "text-center"
}
const _hoisted_5 = {
  key: 0,
  class: "fas fa-check-circle text-success"
}
const _hoisted_6 = {
  key: 1,
  class: "fa fa-times-circle text-danger"
}
const _hoisted_7 = {
  key: 2,
  class: "text-center"
}
const _hoisted_8 = {
  key: 0,
  class: "fas fa-check-circle text-success"
}
const _hoisted_9 = {
  key: 1,
  class: "fa fa-times-circle text-danger"
}
const _hoisted_10 = {
  key: 3,
  class: "text-end"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1 /* HOISTED */)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 4,
  class: "text-end"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-circle-up" }, null, -1 /* HOISTED */)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-circle-down" }, null, -1 /* HOISTED */)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 5,
  class: "text-end"
}
const _hoisted_21 = { class: "fw-bold" }
const _hoisted_22 = {
  key: 6,
  colspan: "4"
}
const _hoisted_23 = {
  key: 0,
  class: "edit-row"
}
const _hoisted_24 = ["colspan"]
const _hoisted_25 = {
  key: 0,
  class: "d-flex justify-content-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyTextHandler = _resolveComponent("EmptyTextHandler")!
  const _component_TablePrompt = _resolveComponent("TablePrompt")!
  const _component_AuthorizedContactForm = _resolveComponent("AuthorizedContactForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", {
      class: _normalizeClass(_ctx.isContactFormOpen || _ctx.isDeleteRequested ? 'edit-row' : '')
    }, [
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.contact.firstName
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, {
          text: _ctx.contact.lastName
        }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, { text: _ctx.roleValues }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, { text: _ctx.relationshipValue }, null, 8 /* PROPS */, ["text"])
      ]),
      _createElementVNode("td", null, [
        _createVNode(_component_EmptyTextHandler, { text: _ctx.primaryPhoneNumber }, null, 8 /* PROPS */, ["text"])
      ]),
      (!_ctx.isDeleteRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
            (_ctx.contact.isEmergencyContact)
              ? (_openBlock(), _createElementBlock("i", _hoisted_2))
              : (_openBlock(), _createElementBlock("i", _hoisted_3))
          ]))
        : _createCommentVNode("v-if", true),
      (!_ctx.isDeleteRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_4, [
            (_ctx.contact.isCahpsSurveyRecipient)
              ? (_openBlock(), _createElementBlock("i", _hoisted_5))
              : (_openBlock(), _createElementBlock("i", _hoisted_6))
          ]))
        : _createCommentVNode("v-if", true),
      (!_ctx.isDeleteRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
            (_ctx.contact.isBereavedContact)
              ? (_openBlock(), _createElementBlock("i", _hoisted_8))
              : (_openBlock(), _createElementBlock("i", _hoisted_9))
          ]))
        : _createCommentVNode("v-if", true),
      (!_ctx.isContactFormOpen && !_ctx.isDeleteRequested && !_ctx.isReOrderRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_10, [
            _createElementVNode("button", {
              type: "button",
              class: "btn table-btn btn-outline-info",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showContactForm(true)))
            }, _hoisted_12),
            _createElementVNode("button", {
              type: "button",
              class: "btn table-btn btn-outline-danger",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.requestDeleteContact())),
              tooltip: "title: Delete Contact"
            }, _hoisted_14)
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.isReOrderRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_15, [
            (_ctx.index !== 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn table-btn btn-outline-info",
                  tooltip: "title: Move Contact Up",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.moveUp(_ctx.index)))
                }, _hoisted_17))
              : _createCommentVNode("v-if", true),
            (_ctx.index !== _ctx.totalContacts - 1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "btn table-btn btn-outline-info",
                  tooltip: "title: Move Contact Down",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.moveDown(_ctx.index)))
                }, _hoisted_19))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.isContactFormOpen)
        ? (_openBlock(), _createElementBlock("td", _hoisted_20, [
            _createElementVNode("i", _hoisted_21, _toDisplayString(_ctx.isEditRequested ? "Editing In Progress" : "View In Progress"), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.isDeleteRequested)
        ? (_openBlock(), _createElementBlock("td", _hoisted_22, [
            _createVNode(_component_TablePrompt, {
              "ok-text": "delete",
              name: "delete",
              "is-in-progress": _ctx.isDeleteInProgress,
              ok: _ctx.deleteContact,
              cancel: _ctx.cancelDeleteContact
            }, null, 8 /* PROPS */, ["is-in-progress", "ok", "cancel"])
          ]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    _createCommentVNode(" Editing "),
    (_ctx.isContactFormOpen)
      ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
          _createElementVNode("td", {
            colspan: _ctx.columns,
            class: "p-3"
          }, [
            _createVNode(_component_AuthorizedContactForm, {
              "is-loading": _ctx.isSaving,
              "relationships-enum": _ctx.relationshipsEnum,
              "contact-roles-enum": _ctx.contactRolesEnum,
              "cahps-survey-contact-enum": _ctx.cahpsSurveyContactEnum,
              contact: _ctx.contactCopy,
              "patient-primary-address": _ctx.patientPrimaryAddress,
              "is-editable": _ctx.isEditRequested,
              "patient-id": _ctx.patientId,
              "total-contacts": _ctx.totalContacts,
              "cahps-survey-recipient-index": _ctx.cahpsSurveyRecipientIndex,
              "close-contact-form": _ctx.closeContactForm,
              "refresh-list": _ctx.refreshList
            }, null, 8 /* PROPS */, ["is-loading", "relationships-enum", "contact-roles-enum", "cahps-survey-contact-enum", "contact", "patient-primary-address", "is-editable", "patient-id", "total-contacts", "cahps-survey-recipient-index", "close-contact-form", "refresh-list"]),
            (!_ctx.isSaving)
              ? (_openBlock(), _createElementBlock("footer", _hoisted_25, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary me-2 mb-2",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.saveContact()))
                  }, "Save"),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-primary mb-2",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closeContactForm()))
                  }, "Cancel")
                ]))
              : _createCommentVNode("v-if", true)
          ], 8 /* PROPS */, _hoisted_24)
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}